import { useEffect, useState } from "react";
import { listUsers, type AutocompleteUser } from "../api/recordings";

/** Same Matrix ID validation as the API. */
export const MXID_RE = /^@[a-z0-9._=\-/+]+:[a-zA-Z0-9.\-]+$/;

/** Choose individual users from Authentik; edits stay local until the parent saves. */
export function UserPicker({ users, onChange, disabled = false, active = true }: {
  users: string[];
  onChange: (users: string[]) => void;
  disabled?: boolean;
  active?: boolean;
}) {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState<AutocompleteUser[]>([]);
  const [searching, setSearching] = useState(false);
  useEffect(() => {
    const trimmed = query.trim();
    if (!active || !trimmed) { setSuggestions([]); setSearching(false); return; }
    let current = true;
    setSearching(true);
    setSuggestions([]);
    const handle = setTimeout(() => {
      void listUsers(trimmed, 20).then(results => {
        if (current) setSuggestions(results);
      }).finally(() => { if (current) setSearching(false); });
    }, 200);
    return () => { current = false; clearTimeout(handle); };
  }, [query, active]);
  const trimmed = query.trim();
  const filtered = suggestions.filter(user => !users.includes(user.mxid));
  const manual = MXID_RE.test(trimmed) && !suggestions.some(user => user.mxid === trimmed) && !users.includes(trimmed);
  const add = (mxid: string) => {
    if (disabled || users.includes(mxid)) return;
    onChange([...users, mxid]);
    setQuery("");
    setSuggestions([]);
  };
  return <>
    {users.length > 0 && <ul className="share-chips">{users.map(user => <li key={user} className="share-chip"><span className="share-chip-text">{user}</span><button type="button" className="share-chip-x" disabled={disabled} onClick={() => onChange(users.filter(value => value !== user))} aria-label={`Убрать ${user}`} title={`Убрать ${user}`}>×</button></li>)}</ul>}
    <div className="share-add">
      <input type="text" className="filter-input input-full" aria-label="Добавить пользователя" placeholder="Добавить пользователя (имя или @user:nan.ru)" disabled={disabled} value={query} onChange={event => setQuery(event.target.value)} />
      {trimmed && <ul className="share-suggestions">
        {filtered.map(user => <li key={user.mxid}><button type="button" className="share-suggestion-row" disabled={disabled} onClick={() => add(user.mxid)}><span className="share-suggestion-name">{user.display_name || user.mxid}</span>{user.display_name && <span className="share-suggestion-mxid muted">{user.mxid}</span>}</button></li>)}
        {manual && <li><button type="button" className="share-suggestion-row" disabled={disabled} onClick={() => add(trimmed)}><span>+ Добавить {trimmed}</span></button></li>}
        {searching && filtered.length === 0 && !manual && <li className="muted share-suggestion-empty">Поиск…</li>}
        {!searching && filtered.length === 0 && !manual && <li className="muted share-suggestion-empty">{suggestions.length ? "Найденные пользователи уже добавлены." : "Не удалось найти пользователя. Можно указать Matrix ID."}</li>}
      </ul>}
    </div>
  </>;
}
